interface DividerProperties {
  className?: string;
  children?: React.ReactNode;
}

export const Divider = ({ className, children }: DividerProperties) => (
  <div className={`border-l-[1px] ${className}`}>{children}</div>
);
